import React, { useContext, useEffect, useState } from 'react';
import { FetchAPI } from "api/fetch";
import { PostAPI } from "api/post.js";
import Dashboard from '../components/LandingPage/DashBoard'
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import moment from "moment";
import { loopBackDomain, loopBackPort } from "environment/environment";
import {
  LandingContainer,
  LandingItems,
  LandingH1,
  LandingP,
} from './home/LandingElements';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
const cookies = new Cookies();


const PageType0 = props => {

  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData?.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const [locationWiseCount, setLocationWiseCount] = useState({});
  const [selected, setSelected] = useState([]);
  let [date, setDate] = useState(moment())
  let arr = [];
  let [previousSelectedDates,setPreviousSelectedDates] = useState()
  let [isLoader, setIsLoader] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [adminLocations, setAdminLocations] = useState()
  let [filters, setFilters] = useState({})
  const [isLoading, setIsLoading] = React.useState(true);
  let [location, setLocation] = useState('all')
  let [loc, setLoc] = useState('all')
  const { t, i18n } = useTranslation();

  let dynamicParameters = {
    user_id: cookies.get('user_id'),
    customer_id: cookies.get('customer_id'),
    src_loc_id: cookies.get('userLocation_id'),
    userRole_name: cookies.get('userRole_name'),
    location: location,
    from_date: date.format('YYYY-MM-DD'),
    to_date: date.format('YYYY-MM-DD'),
    userLocation_id: cookies.get('userLocation_id'),
  }


  const handleLoading = () => {
    setIsLoading(false);
  }

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  }



  const dateFilter = ({ selectedOption, slectedDates, locationsData }) => {
    let from_date = null;
    let to_date = null;
    setPreviousSelectedDates('')
    switch (selectedOption) {
      case '90 days':
        from_date = moment().subtract(89, "days").format("YYYY-MM-DD");
        to_date = moment().format('YYYY-MM-DD')
        break;
      case '30 days':
        from_date = moment().subtract(29, "days").format("YYYY-MM-DD");
        to_date = moment().format('YYYY-MM-DD')
        break;
      case 'today':
        from_date = moment().format("YYYY-MM-DD");
        to_date = moment().format('YYYY-MM-DD');
        break;
      default:
        if (Array.isArray(slectedDates) && slectedDates[0] !== '' && slectedDates[1] !== '') {
          setPreviousSelectedDates(slectedDates)
          from_date = slectedDates[0] 
          to_date =  slectedDates[1] 
        } else {
          from_date = previousSelectedDates ? previousSelectedDates[0] : null
          to_date =  previousSelectedDates ? previousSelectedDates[1] : null
        }
    }
    if (from_date != null && to_date != null) {
      setFilters({
        from_date,
        to_date,
      })
    }
  }




  useEffect(() => {
    (async () => {
      if (pageLayoutData != 'undefined') {
        let totalParams;
        let getURL = pageLayoutData[0].apiEndPoint;
        if (selected.length !== 0 && adminLocations !== undefined && selected.length !== 1) {
          location = selected.length === adminLocations.length ? loc : [...selected.map(loc => loc.value)]
        } else {
          if (selected.length === 0) {
            location = 'null'
          }else if (selected.length === 1)
          location = selected.map((el) => el.value)
        }
        if (pageLayoutData[0].firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[0].firstTimeParameters;
          totalParams = { ...totalParams, ...firstTimeParameters, ...filters }
        }
        if (pageLayoutData[0].apiEndPointType === 'GET') {
          if ((filters.from_date !== null && filters.to_date !== null)) {
            totalParams = { ...totalParams, ...dynamicParameters, ...filters, location : location }
            let paramsConverted = new URLSearchParams(totalParams);
            getURL = (`${getURL}?${paramsConverted.toString()}`);
            setIsLoader(true)
            let responseData = await FetchAPI(getURL);
            if (responseData.status == 200) {
              setIsLoader(false)
              let responseDataJson = await responseData.json();
              if (responseDataJson.data) {
                setLocationWiseCount(responseDataJson.data)
              }
            }
          }
        }
        else {
          totalParams = { ...totalParams, ...dynamicParameters, ...filters}
          let responseData = await PostAPI(getURL, totalParams);
          if (responseData.status == 200) {
          }
        }
      }
    })()
  }, [selected, filters.from_date, filters.to_date])



  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);

  useEffect(() => {
    window.addEventListener("load", handleLoading);
    return () => window.removeEventListener("load", handleLoading);
  }, [])



  useEffect(() => {
    (async () => {
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
      const payload = {
        pageTypeID: 0,
        featureID: 1
      };
      cookies.set('feature_id', 1, { path: '/' });
      await setGlobalLoadIndicator('1');
      let response = await PostAPI(url, payload);
      await setFeatureBlueprint(response);
      await setGlobalLoadIndicator('2');
    })()
  }, [])

  let commonParameters = {
    customer_id: cookies.get('customer_id'),
    user_id: cookies.get('user_id'),
  }

  let domain = (window.location.hostname).split(/[-.]/);
  let clientName = domain[0].toUpperCase()
  Object.keys(locationWiseCount).forEach((el) => {
    if(el.includes('Permission')){
      arr.push(locationWiseCount[el])
    }
  })
  
  return (
    (cookies.get('customer_id') === '13') ? 
    <div className={arr.some((el) => el === true) ? 'content' : null}>
            <Dashboard
              dateFilter={dateFilter}
              isLoader={isLoader}
              count={locationWiseCount}
              setSelected={setSelected}
              setAdminLocations={setAdminLocations} />
      </div>
      :
      <LandingContainer>
        <LandingItems>
          <LandingH1>{t("welcome")} eSeal</LandingH1>
          <LandingP>{clientName}</LandingP>
        </LandingItems>
      </LandingContainer>
  );
}

export default PageType0;
